import * as React from 'react';
import { Status } from '../status/status.component';
export var StatusWrapper = function StatusWrapper(_ref) {
  var statusPosition = _ref.statusPosition,
      error = _ref.error,
      pending = _ref.pending,
      errorIcon = _ref.errorIcon,
      validationErrorMessages = _ref.validationErrorMessages,
      validationMode = _ref.validationMode,
      children = _ref.children;
  var shouldShowErrorIcon = !!(validationErrorMessages === null || validationErrorMessages === void 0 ? void 0 : validationErrorMessages.length) && (validationMode === 'both' || validationMode === 'icon') || error;
  return React.createElement(React.Fragment, null, statusPosition === 'left' && React.createElement(Status, {
    error: shouldShowErrorIcon,
    pending: pending,
    errorIcon: errorIcon,
    cypressTag: "status-left"
  }), children, statusPosition === 'right' && React.createElement(Status, {
    error: shouldShowErrorIcon,
    pending: pending,
    errorIcon: errorIcon,
    cypressTag: "status-right"
  }));
};
StatusWrapper.defaultProps = {
  statusPosition: 'right'
};